import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container', 'pinnedContainer'];

  connect() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      root: null,
      threshold: 0,
    });

    this.observer.observe(this.containerTarget);
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        this.pinnedContainerTarget.classList.add('on-screen');
      } else {
        this.pinnedContainerTarget.classList.remove('on-screen');
      }
    });
  }

  disconnect() {
    this.observer.disconnect();
  }
}
